import {
  CostEstimateRequest,
  CostEstimateResponse,
  CostEstimationCompleteDto,
  CostEstimationDto,
  UpsertCostEstimationDto
} from 'ts-types/api.types';
import axios from './http';
import { CancelTokenSource } from 'axios';

const { REACT_APP_API_BASE_URL: baseUrl } = process.env;
const apiUri = `${baseUrl}/api/cost-estimations`;

export const getAllPatientCostEstimationsByTariffId = (patientId: number, tariffId: number,
                                                       source: CancelTokenSource): Promise<Array<any>> => {
  return axios
      .get(`${apiUri}`,{params: {patientId: patientId, tariffId: tariffId}, cancelToken: source.token})
      .then(response => response.data);
};

export const getUpsertCostEstimation = (costEstimationId: number, source: CancelTokenSource): Promise<any> => {
  return axios
      .get(`${apiUri}/${costEstimationId}`, { cancelToken: source.token })
      .then(response => response.data);
};

export const saveCostEstimation = (upsertCostEstimationDto: Partial<UpsertCostEstimationDto>,
                                   source: CancelTokenSource): Promise<CostEstimationDto> => {
  return axios
      .post(`${apiUri}`, upsertCostEstimationDto, { cancelToken: source.token })
      .then(response => response.data);
};

export const editCostEstimation = (costEstimationId: number, upsertCostEstimationDto: Partial<UpsertCostEstimationDto>,
                                   source: CancelTokenSource): Promise<CostEstimationDto> => {
  return axios
      .put(`${apiUri}/${costEstimationId}`, upsertCostEstimationDto, { cancelToken: source.token })
      .then(response => response.data);
};

export const deleteCostEstimation = (costEstimationId: number, source: CancelTokenSource): Promise<CostEstimationDto> => {
  return axios
      .delete(`${apiUri}/${costEstimationId}`, { cancelToken: source.token })
      .then(response => response.data);
};

export const isCostEstimationComplete = (costEstimationCompleteDto: CostEstimationCompleteDto,
                                         source: CancelTokenSource): Promise<boolean> => {
  return axios
      .post(`${apiUri}/complete`, costEstimationCompleteDto, {cancelToken: source.token})
      .then(response => response.data);
};

export const getTreatmentCostEstimate = (source: CancelTokenSource, costEstimateRequest: CostEstimateRequest): Promise<CostEstimateResponse> => {
  return axios
      .post(`${baseUrl}/api/treatment-cost-estimate`, costEstimateRequest, { cancelToken: source.token })
      .then(response => response.data);
};
